/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface OnGoingSkmGridListResponse {
    onGoingSKMGridList: OnGoingSKMGridListItem[];
}

export interface OnGoingSKMGridListItem {
    compulsoryId: string;
    careerSubTitle: string;
    cmid: string;
    cmtitle: string;
    organizer: string;
    updateUserIdName: string;
    updateDate: string;
    compulsoryCssClass: string;
}

class OnGoingSkmGridListService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "onGoing/skmGridList");
    }

    public async onGoingSkmGridList(resolved: (response: OnGoingSkmGridListResponse) => void, rejected: (error: any) => void) {
        await super.getJSON((json: any) => {
            const response = json as OnGoingSkmGridListResponse;
            resolved(response);
        }, rejected);
    }

    public async getResponse(): Promise<OnGoingSkmGridListResponse> {
        return super.getWithPromise().then((json: any) => {
            const response = json as OnGoingSkmGridListResponse;
            return response;
        });
    }
}

export default OnGoingSkmGridListService;
